export const ROUTES = {
  dashboard: "/dashboard",
  userManagement: "/user-management",
  noticeManagement: "/notice-management",
  customerManagement: "/customer-management",
  customerLogin: "/login",
  userLogin: "/user/login",
  edo: "/edo",
  unauthorizedAccess: "/no-access",
  settings: "/settings",
  mdo: "/mdo",
  accessManagement: "/access-management",
  forgotPassword: "/forgot-password",
  changePassword: "/change-password",
  creditBankSlipReUpload: "/credit-bankslipreupload",
  invoiceRequests: "/invoice-requests",
  approvals: "/approvals",
  terminalManagement: "/terminal-management",
  vesselNotice: "/vessel-notice",
  gensoftTrackTrace: "/gensoft-track-trace",
  salesNomination: "/sales-nomination",
  staffLogin: "/staff",
};
